import { hasCapability, type User } from "../base";

export const insurance = {
  viewNonOptimisticStatus: (user: User) => hasCapability(user, "insurance.viewNonOptimisticStatus"),
  createAssignment: (user: User) => hasCapability(user, "insurance.createAssignment"),
};
